//must have props/state for:
//Movies.js: "Your Movies"
//Profile.js: "Profile"
import React from "react";

const Header = (props) => {
  return (
    <div className="header">
      <h1 className="header-text">{props.title}</h1>
    </div>
  );
};

export default Header;
